/**
 * Returns the size of an image
 * @param {number} bytes
 * @param {number} decimals
 * @returns {string} a concatanated string
 */
export function formatBytes(bytes, decimals = 2) {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

/**
 * Returns array of objects with preview, formattedSize, base64 of an image as props
 * @param {array} files
 * @returns {array}
 */
export const handleAcceptedFiles = files => {
  return files.map(file => {
    return Object.assign(file, {
      preview: URL.createObjectURL(file),
      formattedSize: formatBytes(file.size),
      base64: getBase64(file)
    });
  });
};

/**
 * Returns a base64 string of an image
 * @param {file} file
 * @returns {string} base64
 */
function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}
